var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExitNodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 4.8,
    fill: "#475569"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_27884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1933 14.8598C12.4533 15.1198 12.8733 15.1198 13.1333 14.8598L15.5267 12.4664C15.7867 12.2064 15.7867 11.7864 15.5267 11.5264L13.1333 9.13309C12.8733 8.87309 12.4533 8.87309 12.1933 9.13309C11.9333 9.39309 11.9333 9.81309 12.1933 10.0731L13.4467 11.3331H7.66667C7.3 11.3331 7 11.6331 7 11.9998C7 12.3664 7.3 12.6664 7.66667 12.6664H13.4467L12.1933 13.9198C11.9333 14.1798 11.94 14.6064 12.1933 14.8598ZM17.6667 5.99976H8.33333C7.59333 5.99976 7 6.59976 7 7.33309V9.33309C7 9.69976 7.3 9.99976 7.66667 9.99976C8.03333 9.99976 8.33333 9.69976 8.33333 9.33309V7.99976C8.33333 7.63309 8.63333 7.33309 9 7.33309H17C17.3667 7.33309 17.6667 7.63309 17.6667 7.99976V15.9998C17.6667 16.3664 17.3667 16.6664 17 16.6664H9C8.63333 16.6664 8.33333 16.3664 8.33333 15.9998V14.6664C8.33333 14.2998 8.03333 13.9998 7.66667 13.9998C7.3 13.9998 7 14.2998 7 14.6664V16.6664C7 17.3998 7.6 17.9998 8.33333 17.9998H17.6667C18.4 17.9998 19 17.3998 19 16.6664V7.33309C19 6.59976 18.4 5.99976 17.6667 5.99976Z",
    fill: "#F2F4F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_27884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitNodeIcon);
export default __webpack_public_path__ + "static/media/exitNodeIcon.848f1c1925820ca44bf958b1cd52b37a.svg";
export { ForwardRef as ReactComponent };